/**
 * URL
 */
export enum URL {
  /**
   * BaseURL
   */
  //  BaseURL = 'https://airspo.synology.me:12345',
  BaseURL = 'https://airspo.synology.me:12345/public',
  /**
   * 住所検索
   */
  AddressSearch = 'zip/getAddressSearch',
  /**
   * 郵便番号検索
   */
  ZipSearch = 'zip/getZipSearch',
}

/**
 * 戻り値のタイプ
 * @name ResultType
 */
export enum ResultType {
  /**
   * 成功
   * @name Success
   */
  Success = 0,
  /**
   * システムエラー
   * @name SystemError
   */
  SystemError = -9,
}

/**
 * ダイアログタイプ
 */
export enum DialogType {
  /**
   * OKのみ
   */
  OKOnly,
  /**
   * Loading
   */
  Loading,
}
